<nz-modal
  nzWrapClassName="form-modal-expert"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  [nzWidth]="completeData && !welcomeMessage ? '40%' : '65%'"
  [nzClosable]="notClosable"
  (nzOnCancel)="onEmitCloseModal(false)"></nz-modal>


<ng-template #modalTitle>
  <div class="container-steps-modal" [@fadeInAnimation]>
    <h2 class="text-title-md-bold title-modal" *ngIf="!completeData">{{ expert?._id ? 'Actualizar experto' : 'Nuevo experto' }}</h2>
    <h2 class="text-title-md-bold title-modal" *ngIf="completeData && welcomeMessage">¡Hola, {{ expert.user?.name + ' ' + expert.user?.lastname }}!</h2>
    <p class="text-info mt-xxs" *ngIf="!completeData">{{ expert._id ? 'Se actualizará el experto' : 'Se agregará un nuevo usuario experto a la clínica' }}</p>
    <p class="text-info mt-xxs" *ngIf="completeData && welcomeMessage">Por favor completa tu perfil para continuar.</p>
  </div>
</ng-template>


<ng-template #modalContent>
  <div class="container-modal" [@fadeInAnimation] *ngIf="expert">


    <!-- cuando es completar perfil antes debe salir un mensaje -->
    <div *ngIf="completeData && !welcomeMessage" class="tw-w-full">
      <p class="mb-xlg text-center">
        <i nz-icon nzType="check-circle" nzTheme="twotone" style="font-size: 50px;" [nzTwotoneColor]="'#52c41a'"></i>
      </p>
      <p class="text-title-lgx-bold mb-md text-center">¡Tu clínica ha sido creada con éxito!</p>
      <p class="text-info text-upper-case text-center">Ahora puedes completar tu perfil de experto para comenzar a trabajar.</p>

      <div class="d-flex justify-content-center mt-xlg">
        <button nz-button nzType="primary" (click)="onViewForm()">Completar mi perfil de experto</button>
      </div>
    </div>


    <form #expertForm="ngForm" *ngIf="expert.user && ((completeData && welcomeMessage) || !completeData)">
      <div nz-row nzGutter="16">
        <div nz-col nzXs="24" nzSm="8" class="mb-sm">
          <div class="input-label-form">Nombre</div>
          <input nz-input [required]="true" [(ngModel)]="expert.user.name" #ngName="ngModel" name="name" placeHolder="Nombre del usuario">
          <app-message-field [field]="ngName"></app-message-field>
        </div>

        <div nz-col nzXs="24" nzSm="8" class="mb-sm">
          <div class="input-label-form">Apellidos</div>
          <input nz-input
            [required]="true"
            [(ngModel)]="expert.user.lastname"
            #ngLastname="ngModel" name="lastname" placeHolder="Apellidos del usuario">
          <app-message-field [field]="ngLastname"></app-message-field>
        </div>

        <div nz-col nzXs="24" nzSm="8" class="mb-sm">
          <div class="input-label-form">Género</div>
          <nz-select
            [(ngModel)]="expert.user.gender"
            [nzPlaceHolder]="'Género'"
            [required]="true"
            name="ngGender"
            #ngGender="ngModel">
            <nz-option [nzValue]="this.genderEnum.MALE" nzLabel="Masculino"></nz-option>
            <nz-option [nzValue]="this.genderEnum.FEMALE" nzLabel="Femenino"></nz-option>
          </nz-select>
          <app-message-field [field]="ngGender"></app-message-field>
        </div>
      </div>

      <div nz-row nzGutter="16">
        <div nz-col nzXs="24" nzSm="8" class="mb-sm">
          <div class="input-label-form">Correo electrónico</div>
          <input nz-input [required]="true" [(ngModel)]="expert.user.email" #ngEmail="ngModel" name="email" placeHolder="Correo electrónico"
            (ngModelChange)="helperValidationField.onValidateEmail(expert.user.email, ngEmail)">
          <app-message-field [field]="ngEmail"></app-message-field>
        </div>

        <div nz-col nzXs="24" nzSm="8" class="mb-sm">
          <div class="input-label-form">Fecha de nacimiento</div>
          <nz-date-picker [required]="true" [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY" [(ngModel)]="expert.user.birthday" #ngbirthday="ngModel" name="birthday"
            nzPlaceHolder="Fecha de nacimiento" [nzDisabledDate]="utilitiesServices.disabledDate"></nz-date-picker>
          <app-message-field [field]="ngbirthday"></app-message-field>
        </div>

        <div nz-col nzXs="24" nzSm="8" class="mb-sm">
          <div class="input-label-form">Especialidad</div>
          <nz-select
            [(ngModel)]="this.expert.specializationId"
            name="ngProfession"
            nzPlaceHolder="Seleccione"
            [required]="true"
            #ngProfession="ngModel">
            <nz-option *ngFor="let specialization of (specializations$ | async)" [nzValue]="specialization._id" [nzLabel]="specialization.name"></nz-option>
          </nz-select>
          <app-message-field [field]="ngProfession"></app-message-field>
        </div>
      </div>

      <div nz-row nzGutter="16">
        <div nz-col nzXs="24" nzSm="8" class="mb-sm">
          <div class="input-label-form">Zona horaria</div>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Seleccione" [required]="true" [(ngModel)]="expert.user.timeZone" #ngTimeZone="ngModel"
            name="timeZone">
            <nz-option *ngFor="let timeZone of timeZones;" [nzLabel]="timeZone" [nzValue]="timeZone"></nz-option>
          </nz-select>
          <app-message-field [field]="ngTimeZone"></app-message-field>
        </div>
        <div nz-col nzXs="24" nzSm="8" class="mb-sm" *ngIf="!completeData">
          <div class="input-label-form">Sucursal</div>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Seleccione" [required]="true" [(ngModel)]="clinicBranchIdSelected" #ngBranch="ngModel"
            name="branch">
            <nz-option *ngFor="let branch of (clinicBranches$ | async);" [nzLabel]="branch.name" [nzValue]="branch._id"></nz-option>
          </nz-select>
          <app-message-field [field]="ngBranch"></app-message-field>
        </div>
      </div>

      <div nz-row [nzGutter]="[30, 30]">
        <div nz-col nzSpan="24">
          <div class="card-container-shadow public-info">
            <p class="input-label-form">Semblanza del experto</p>
            <textarea
              nz-input
              [(ngModel)]="expert.publicInformation"
              #ngPublicInformation="ngModel"
              [required]="true"
              name="ngPublicInformation"
              placeholder="Todo lo escrito aquí será mostrado a los usuarios"
              [nzAutosize]="{ minRows: 6, maxRows: 6 }"></textarea>
            <app-message-field [field]="ngPublicInformation"></app-message-field>
          </div>
        </div>
      </div>

      <nz-alert nzType="info"
        class="tw-w-full mt-xs mb-xs"
        nzMessage="Parte de esta información será mostrada a tus pacientes durante las citas o para contacto." nzShowIcon></nz-alert>
      <nz-divider></nz-divider>

      <div nz-row [nzGutter]="[30, 30]">
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="16">
          <app-address-section
            [address]="this.expert.user.address"
            [removeClassCardContainerShadow]="true"></app-address-section>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="8">
            <app-phones
            [phones]="this.expert.user.phones"
            [removeClassCardContainerShadow]="true"></app-phones>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #modalFooter>
  <div class="container-footer-modal" [@fadeInAnimation]>
    <button
      *ngIf="!completeData"
      style="margin-right: 5px;"
      (click)="onEmitCloseModal(false)"
      nz-button nzType="cancel">
      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
      CANCELAR</button>
    <button
      *ngIf="!completeData"
      (click)="onEmitCloseModal(true)"
      nz-button nzType="primary">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Crear experto</button>
    <button
      *ngIf="completeData && welcomeMessage"
      (click)="onEmitCloseModal(true)"
      nz-button nzType="primary">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Guardar datos</button>
  </div>
</ng-template>
